import Highway from '@dogstudio/highway/src/highway'
import gsap from 'gsap'
import LocomotiveScroll from 'locomotive-scroll'

import { debounce } from 'underscore'
import ContactIcon from './modules/ContactIcon'
import MotionTime from './modules/MotionTime'

import '../scss/_ListingCreas.scss'
import FryItUp from './modules/FryItUp'

export default class ListingCreas extends Highway.Renderer {
    onEnter() {
        window.scrollTo(0, 0)
        this.allWorks = [...document.querySelectorAll('.works__listing .work')]
        this.prepareAnimations()
        this.motionTime = new MotionTime()
    }

    onEnterCompleted() {
        let hoverTimer = null

        this.enteringTimeline.play()

        const containers = [
            document.querySelector('.hover__visuel-one'),
            document.querySelector('.hover__visuel-two'),
            document.querySelector('.hover__visuel-three'),
        ]

        for (let work of this.allWorks) {
            work.addEventListener('mouseenter', (e) => {
                let visuels = []
                visuels.push(work.getAttribute('data-visuel-one'))
                visuels.push(work.getAttribute('data-visuel-two'))
                visuels.push(work.getAttribute('data-visuel-three'))

                if (!work.classList.contains('active')) {
                    clearTimeout(hoverTimer)
                    hoverTimer = null
                    // Handling active classes to avoid animating when already active
                    let currentActiveWork = document.querySelector(
                        '.works__listing .work.active'
                    )
                    if (currentActiveWork) {
                        currentActiveWork.classList.remove('active')
                    }

                    work.classList.add('active')

                    gsap.to(containers, {
                        scale: 1.2,
                        opacity: 0,
                        duration: 0.1,
                        ease: 'expo.easeOut',
                        onComplete: () => {
                            for (let i = 0; i < containers.length; i++) {
                                if (visuels[i] !== '') {
                                    containers[i]
                                        .querySelector('img')
                                        .setAttribute('src', visuels[i])
                                } else {
                                    containers[i]
                                        .querySelector('img')
                                        .setAttribute('src', '')
                                }
                            }

                            gsap.to(containers, {
                                stagger: 0.05,
                                opacity: 1,
                                duration: 0.2,
                                scale: 1,
                                ease: 'expo.easeOut',
                            })
                        },
                    })
                }
            })

            work.addEventListener(
                'mouseleave',
                debounce((e) => {
                    // for (let i = 0; i < containers.length; i++) {
                    //     containers[i].classList.remove('active');
                    // }
                    hoverTimer = setTimeout(() => {
                        gsap.to(containers, {
                            scale: 1.2,
                            opacity: 0,
                            duration: 0.1,
                            ease: 'expo.easeOut',
                            onComplete: () => {
                                let currentActiveWork = document.querySelector(
                                    '.works__listing .work.active'
                                )
                                if (currentActiveWork) {
                                    currentActiveWork.classList.remove('active')
                                }
                            },
                        })
                    }, 500)
                }),
                200
            )
        }

        this.fryItUpInstance = new FryItUp()

        // Init scroll system
        this.scroll = new LocomotiveScroll({
            smooth: true,
            smoothMobile: true,
            el: document.querySelector('[data-scroll-container]'),
            inertia: 0.75,
            offset: ['35%', 0],
        })

        this.scroll.init()

        // scroll header fix
        const header = document.querySelector('.header')

        this.scroll.on('scroll', (e) => {
            const currentScroll = e.scroll.y
            currentScroll > 10
                ? header.classList.add('smaller')
                : header.classList.remove('smaller')

            // Fryitup : au scroll on stop l'event. Il faut rester sans bouger.
            let activeFryItUpHover = document.querySelector(
                '.works__listing .work.fryitup--charging'
            )
            if (activeFryItUpHover) {
                this.fryItUpInstance.leavingEvent(activeFryItUpHover)
            }
        })

        const contactIconInstance = new ContactIcon(
            'locomotive-scroll',
            this.scroll
        )
    }

    prepareAnimations() {
        this.enteringTimeline = new gsap.timeline({
            paused: true,
        })

        this.enteringTimeline.add(
            gsap.fromTo(
                this.allWorks,
                {
                    scale: 1.4,
                    opacity: 0,
                },
                {
                    scale: 1,
                    stagger: 0.1,
                    ease: 'expo.easeOut',
                    duration: 0.2,
                    opacity: 1,
                }
            )
        )
    }

    onLeave() {
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 200)
        this.scroll.destroy()

        gsap.to(this.allWorks, {
            duration: 0.1,
            stagger: 0.05,
            opacity: 0,
            scale: 1.4,
            ease: 'expo.easeOut',
        })

        this.fryItUpInstance.destroyAll()
    }
}
